import { render } from "./MainView.vue?vue&type=template&id=62abdc6d&scoped=true&ts=true"
import script from "./MainView.vue?vue&type=script&lang=ts"
export * from "./MainView.vue?vue&type=script&lang=ts"

import "./MainView.vue?vue&type=style&index=0&id=62abdc6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62abdc6d"]])

export default __exports__